<div class="description-container">

    <!-- Rest of the component remains the same -->
    <div class="title-container">
      <h3 class="db-title text-center"
          [ngClass]="{ 'fade-in': showAnalyzingTitle, 'fade-out': showEnhancedTitle }">
        {{ companyName }} AI is analyzing your input to craft the perfect website
      </h3>
      <!--   <h3 class="db-title text-center" [ngClass]="{ 'fade-in': showInitialTitle, 'fade-out': showEnhancedTitle }">
           AI is diving deep to capture every important detail
         </h3>-->
      <h3 class="db-title enhanced-title text-center" [ngClass]="{ 'fade-in': showEnhancedTitle, 'fade-out':
        showOutlineTitle}">
        Optimizing your content for clarity and impact
      </h3>
    </div>

    <div class="description-content-container">
      <div class="description-content initial text-container"
           [ngClass]="{ 'fade-up': showInitialDescription, 'fade-out': !showInitialDescription }">
        <span class="black-text">{{ (builderInteractionsService.prefilledDescription.value || data?.initial_description) | capitalizeFirst }}</span>
        <span class="gradient initial">{{  (builderInteractionsService.prefilledDescription.value || data?.initial_description) | capitalizeFirst}}</span>
      </div>
      <div class="text-container-enhanced" textFadeIn [animationDuration]="900" [delay]="150" *ngIf="showEnhancedDescription"
           [ngClass]="{'fade-out': showOutlineTitle}">
        {{ data?.site_description }}
      </div>
    </div>
  </div>
